import {checkAndUpdateToken} from "./auth";
import {
    ENCRYPTION_KEYS,
    ENCRYPTION_KEYS_LOADING,
    APPLICANT,
    APPLICANT_LOADING,

    SET_STUDY_YEAR,
    SET_CATEGORY_APLICANT,
    SET_FACULTY,
    SET_TRAINING_DIRECT,
    SET_APPLICANT_PAGES_COUNT
} from "./types";
import {BACKEND_URL_PREFIX, itemsOnPage} from "../utils/const";
import {buildDefaultHeaders} from "./helper";
import {createNotification} from "../components/notifications/notifications";
import timer from 'timers-promises'

export const getGpgKey = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    
    dispatch({type: ENCRYPTION_KEYS_LOADING, payload: true});
    if (getState().auth.token) {
        try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/gpg_key`, buildDefaultHeaders(getState));

        if (response.ok) {
            const result = await response.json();
            dispatch({type: ENCRYPTION_KEYS, payload: result});
        } else {
            createNotification('error', 'Ошибка');
        }
        } catch (ERR) {
            dispatch({type: ENCRYPTION_KEYS, payload: {}});
            createNotification('error', 'Ошибка')
        } finally {dispatch({type: ENCRYPTION_KEYS_LOADING, payload: false});}
    }
};

export const addGpg = (data, forse) => async(dispatch, getState) => {
    let formData = new FormData();
    formData.append("file", data);

    await dispatch(checkAndUpdateToken());
    if (!getState().auth.token) 
        return;
    try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/gpg_key${forse ? `?force=true` : ''}`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`,
              },
            method: "POST",
            body: formData
        });

        if (response.ok) {
            createNotification('success', 'Усрешно');
            dispatch(getGpgKey());
        } else {
            createNotification('error', 'Ошибка');
        }
    } catch (ERR) {} finally {}
};

export const setPage = (pageNumber) => ({type: SET_APPLICANT_PAGES_COUNT, payload: {pageNumber: pageNumber}})

export const getApplicant = (filters) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    
    const { pageNumber } = getState().encryptionKeys;
    const limit = itemsOnPage;
    const offset = itemsOnPage * pageNumber;
    
    const filters_ = Object.entries({...filters, limit: limit, offset: offset}).reduce((acc, [key, value]) => {
        if (value != null && value !== '') acc[key] = value;
        return acc;
      }, {});

    dispatch({type: APPLICANT_LOADING, payload: true});
    if (getState().auth.token) {
        try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/applicant?${new URLSearchParams(filters_).toString()}`, buildDefaultHeaders(getState));

        if (response.ok) {

            const {count: count, applicants} = await response.json();
            const pageCount = Math.ceil(count / itemsOnPage);

            dispatch({ type: APPLICANT, payload: applicants });
            dispatch({ type: SET_APPLICANT_PAGES_COUNT, payload: {pageCount: pageCount, count: count} });

        } else {
            createNotification('error', 'Ошибка');
        }
        } catch (ERR) {
            dispatch({type: APPLICANT, payload: {}});
            createNotification('error', 'Ошибка')
        } finally {dispatch({type: APPLICANT_LOADING, payload: false});}
    }
};

export const addApplicant = (data, filters) => async (dispatch, getState) => {
    let formData = new FormData();
    formData.append("file", data);
    dispatch({type: APPLICANT_LOADING, payload: true});
    await dispatch(checkAndUpdateToken());
    if (!getState().auth.token) 
        return;
    try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/import_applicant `, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`,
              },
            method: "POST",
            body: formData
        });

        const data = await response.json();
        if (response.status === 202) {
            dispatch({type: APPLICANT_LOADING, payload: true});
            dispatch(getStatus(data.task_id, filters));
        } else {
            createNotification('error', data.gpg_result, data.error);
        }
    } catch (ERR) {
    } finally {
        dispatch({type: APPLICANT_LOADING, payload: false});
    }
};

export const getStatus = (hash, filters) => async (dispatch, getState) => {
    let result = []
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/import_applicant_task/${hash}`,
      {
        method: "GET",
        ...buildDefaultHeaders(getState),
      }
    );
    
      const data = await response.json();
      if (data.status === 'in_progress') {
        await timer.setTimeout(5000);
        result = await dispatch(getStatus(hash, filters));
      } else if (data.status === 'failed') {
        createNotification('error', 'Ошибка');
        dispatch({type: APPLICANT_LOADING, payload: false});
        dispatch(getApplicant(filters));
      } else {
        dispatch({type: APPLICANT_LOADING, payload: false});
        dispatch(getApplicant(filters));
        createNotification(
            'success', 
            `${
                data
                .result
                .map((el, inx) => (inx !== data.result.length - 1 && data.result.length > 1) ? el.lastname : ` ${el.lastname}`)}`, 
            `Успешно, добавлено ${data.result.length} записей`)
      }
    
    return result
  }

  //////////////////api for filters
  export const getStudyYear = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/year/scy`, buildDefaultHeaders(getState));

        if (response.ok) {
            const result = await response.json();
            dispatch({type: SET_STUDY_YEAR, payload: result.schoolYear.reverse()});
        } else {
            createNotification('error', 'Ошибка');
        }
        } catch (ERR) {
            dispatch({type: SET_STUDY_YEAR, payload: []});
            createNotification('error', 'Ошибка')
        } finally {}
    }
};

export const getEduProgram = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/preparation_structure`, buildDefaultHeaders(getState));

        if (response.ok) {
            const result = await response.json();
            dispatch({type: SET_CATEGORY_APLICANT, payload: result});
        } else {
            createNotification('error', 'Ошибка');
        }
        } catch (ERR) {
            dispatch({type: SET_CATEGORY_APLICANT, payload: []});
            createNotification('error', 'Ошибка')
        } finally {}
    }
};

export const getFaculty = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/faculty?limit=1000&offset=0&web=1`, buildDefaultHeaders(getState));

        if (response.ok) {
            const result = await response.json();
            dispatch({type: SET_FACULTY, payload: result.items});
        } else {
            createNotification('error', 'Ошибка');
        }
        } catch (ERR) {
            dispatch({type: SET_FACULTY, payload: []});
            createNotification('error', 'Ошибка')
        } finally {}
    }
};

export const getTrainingDirect = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/all_train_dirs`, buildDefaultHeaders(getState));

        if (response.ok) {
            const result = await response.json();
            dispatch({type: SET_TRAINING_DIRECT, payload: result});
        } else {
            createNotification('error', 'Ошибка');
        }
        } catch (ERR) {
            dispatch({type: SET_TRAINING_DIRECT, payload: []});
            createNotification('error', 'Ошибка')
        } finally {}
    }
};